import * as serviceInitTypes from './serviceInitTypes';
import { SI_ADD_APPLICANT_VIEWS, SI_ADDINITIATION_VIEWTYPES } from 'src/constants/constants';
import cloneDeep from 'lodash.clonedeep';

const manualInitiationMenu = [
  {
    menuName: 'Services Details',
    viewType: SI_ADDINITIATION_VIEWTYPES.SELECT_SERVICETYPE,
    pageState: null,
    isFormUpdated: false,
  },
  {
    menuName: 'Add Employee/Applicant',
    viewType: SI_ADDINITIATION_VIEWTYPES.ADD_APPLICANT,
    pageState: null,
    isFormUpdated: false,
  },
];

const batchInitiationMenu = [
  { menuName: 'Services Details', viewType: SI_ADDINITIATION_VIEWTYPES.SELECT_SERVICETYPE, pageState: null, isFormUpdated: false },
];

const initialState = {
  addInitiation: {
    viewType: SI_ADDINITIATION_VIEWTYPES.SELECT_SERVICETYPE,
    error: null,
    engagement: -1,
    country: '',
    initiationType: -1,
    serviceType: '',
    employee: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      dateOfBirth: '',
      passportCountry: '',
      contactNumber: '',
      relationshipStatus: '',
      employeeCode: '',
    },
    currentMenuPage: 0,
    menu: cloneDeep(batchInitiationMenu),
    viewOrder: batchInitiationMenu.map(item => item.viewType).concat(SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT),
    addApplicantViewType: SI_ADD_APPLICANT_VIEWS.SEARCH,
    addEmployeeData: null /* if a user creates a new employee we need this global b/c of menu left/right buttons */,
    dynamicContent: {},
    dynamicFormValues: {},
    progress: 1,
  },
  isLoading: false,
  isNextEnabled: true,
  engagementList: [],
  serviceTypeList: [],
  initiationTypeList: [],
  passportCountryList: [],
  countryList: [],
  employeeTypeList: [],
  relationshipStatusList: [],
  showFilterModal: false,
  filters: {},
};

const serviceInitReducer = (state = initialState, action) => {
  switch (action.type) {
    case serviceInitTypes.GET_ENGAGEMENT_SUCCESS:
      return { ...state, engagementList: action.data };

    case serviceInitTypes.GET_INITIATIONTYPE_SUCCESS:
      return { ...state, initiationTypeList: action.data };

    case serviceInitTypes.CREATE_ORGANIZER_SUCCESS:
    case serviceInitTypes.RESUME_INITIATION_SUCCESS:
      return {
        ...state,
        addInitiation: {
          ...state.addInitiation,
          dynamicContent: action.data,
          menu: action.menu,
          isOrganizerCreated: true,
          viewOrder: action.viewOrder,
          ...action.options,
        },
      };

    case serviceInitTypes.SET_NEXT_DISABLED:
      return { ...state, isNextEnabled: false };

    case serviceInitTypes.SET_NEXT_ENABLED:
      return { ...state, isNextEnabled: true };

    case serviceInitTypes.SET_MANUAL_INITIATION:
      return {
        ...state,
        addInitiation: {
          ...state.addInitiation,
          menu: action.menu,
          viewOrder: action.viewOrder,
          initiationType: action.initiationType,
          isOrganizerCreated: false,
          dynamicFormValues: {},
          dynamicContent: {},
          organizerInfo: {},
          serviceType: initialState.addInitiation.serviceType,
          country: initialState.addInitiation.country,
          progress: initialState.addInitiation.progress,
        },
      };

    case serviceInitTypes.SET_BATCH_INITIATION_LOADING:
      return {
        ...state,
        addInitiation: {
          ...state.addInitiation,
          initiationType: action.initiationType,
          isOrganizerCreated: false,
          dynamicFormValues: {},
          dynamicContent: {},
          organizerInfo: {},
          serviceType: initialState.addInitiation.serviceType,
          country: initialState.addInitiation.country,
          progress: initialState.addInitiation.progress,
          ...action.batchOptions,
        },
      };

    case serviceInitTypes.SET_BATCH_INITIATION_COMPLETE:
      return {
        ...state,
        addInitiation: {
          ...state.addInitiation,
          menu: action.menu,
          viewOrder: action.viewOrder,
          isNextEnabled: true,
        },
      };

    case serviceInitTypes.UPDATE_MENU:
      return { ...state, addInitiation: { ...state.addInitiation, menu: action.menu, progress: action.progress } };

    case serviceInitTypes.GET_SISHOWORGANIZER_SUCCESS:
      return {
        ...state,
        addInitiation: { ...state.addInitiation, dynamicContent: action.data, menu: action.menu, progress: action.progress },
      };

    case serviceInitTypes.GET_SERVICETYPE_SUCCESS:
      return { ...state, serviceTypeList: action.data };

    case serviceInitTypes.SET_ADDINITIATION_VALUE:
      return { ...state, addInitiation: { ...state.addInitiation, [action.field]: action.data, menu: action.menu } };

    case serviceInitTypes.RESET_INITIATION:
      return { ...state, addInitiation: cloneDeep(initialState.addInitiation) };

    case serviceInitTypes.RESET_DYNAMIC_CONTENT:
      return {
        ...state,
        addInitiation: { ...state.addInitiation, dynamicContent: {}, dynamicFormValues: {}, menu: action.menu },
      };

    case serviceInitTypes.RESET_EMPLOYEE:
      return { ...state, addInitiation: { ...state.addInitiation, employee: initialState.addInitiation.employee, menu: action.menu } };

    case serviceInitTypes.RESET_DYNAMIC_FORMVALUES:
      return { ...state, addInitiation: { ...state.addInitiation, dynamicFormValues: {} } };

    case serviceInitTypes.GET_SI_CHANGEPAGE:
      return {
        ...state,
        addInitiation: {
          ...state.addInitiation,
          menu: action.menu,
          viewOrder: action.viewOrder,
          viewType: action.viewType,
          currentMenuPage: action.currentMenuPage,
        },
      };

    case serviceInitTypes.CREATE_NEWEMPLOYEE_SUCCESS:
      return {
        ...state,
        addInitiation: { ...state.addInitiation, error: null, employee: { ...state.addInitiation.employee, ...action.data } },
      };

    case serviceInitTypes.CREATE_NEWEMPLOYEE_FAILURE:
      return { ...state, addInitiation: { ...state.addInitiation, error: action.data.error } };

    case serviceInitTypes.GET_PASSPORT_COUNTRYLIST_SUCCESS:
      return { ...state, passportCountryList: action.data };

    case serviceInitTypes.GET_COUNTRYLIST_SUCCESS:
      return { ...state, countryList: action.data };

    case serviceInitTypes.GET_PASSPORT_RELATIONSHIPSTATUS_SUCCESS:
      return { ...state, relationshipStatusList: action.data };

    case serviceInitTypes.GET_EMPLOYEETYPELIST_SUCCESS:
      return { ...state, employeeTypeList: action.data };

    case serviceInitTypes.SSI_SHOW_LOADING:
      return { ...state, isLoading: true };

    case serviceInitTypes.SSI_HIDE_LOADING:
      return { ...state, isLoading: false };

    case serviceInitTypes.GET_FILTERS_SUCCESS:
      return { ...state, filters: action.payload.messages };

    case serviceInitTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };

    default:
      return state;
  }
};

export { initialState, manualInitiationMenu, batchInitiationMenu };
export default serviceInitReducer;



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/state/serviceInitReducer.js